import { PersonBenefits } from '@esportal/portal-service/src/models/benefits';
import { GetPersonUser } from '@esportal/portal-service/src/models/portal';
import { styled } from '@volkswagen-onehub/components-core';
import React from 'react';
import { HuchaVentaCard } from './hucha-venta/components/card/hucha-venta-card';
import { useHuchaValues } from './shared/hooks/use-hucha-values';
import { HuchaVentaValues } from './shared/models/hucha-values';

const StyledHuchaContainer = styled.div`
	display: flex;
	flex-wrap: wrap;
	gap: var(--size-dynamic0100);

	& > div {
		flex: 1;
	}

	@media (min-width: 960px) {
		flex-wrap: nowrap;
	}
`;

export const HuchaContainer = ({
	userData,
	personBenefits,
}: {
	userData: GetPersonUser | null;
	personBenefits: PersonBenefits;
}) => {
	const huchaVentaValues = useHuchaValues(userData, personBenefits, 'venta') as HuchaVentaValues;
	// const huchaPosventaValues = useHuchaValues(userData, personBenefits, 'posventa') as HuchaPosventaValues | null;
	return (
		<>
			<StyledHuchaContainer>
				{huchaVentaValues && <HuchaVentaCard huchaValues={huchaVentaValues} />}
				{/* {huchaPosventaValues && <HuchaPosventaCard huchaValues={huchaPosventaValues} />} */}
			</StyledHuchaContainer>
		</>
	);
};
